import React, { useContext, useMemo, useCallback, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminAuthContext from "../../../store/adminStore/admin-auth-context";

import FormSupport from "./FormSupport";
// import useDraft from "../../../hooks/useDraft";
import useHttpFetch from "../../../hooks/useHttpFetch";
import useFieldAccess from "../../../hooks/useFieldAccess";
import formValidator from "../../../utils/validations/formValidatorV2";
import post from "../../../utils/apiCalls/post";
import put from "../../../utils/apiCalls/putV2";
import useEnum from "../../../hooks/useEnum";

import { Grid } from "@mui/material";
import HasThisFieldAccess from "../../../Components/HasThisFieldAccess/HasThisFieldAccess";
import FormContainer from "../../../Components/UI/FormContainer/FormContainer";
import FormActionSection from "../../../Components/UI/FormActionSection/FormActionSection";

import MultiLanTxt from "../../../Components/UI/MultiLanTxt/MultiLanTxt";
import SimpleInput from "../../../Components/UI/SimpleInputV1/SimpleInput";
import Suggestion from "../../../Components/UI/SuggestionV2/Suggestion";
import removeDuplicatesFromArray from "../../../utils/filters/removeDuplicatesFromArray";
import viewToViewValidity from "../../../utils/formSupportCreator/viewToViewValidity";
import mapper from "../../../utils/formSupportCreator/mapper";
import { toast } from "react-toastify";
import classes from "./FormRow.module.css";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import CircularProgress from "@mui/material/CircularProgress";

const FormNetworkMarketerForm = ({
  editedData,
  setHideSelectedData,
  setEditedData,
  sendReqPerChange,
  dataLimit,
  currentPage,
  sortIconName,
  searchVal,
  actionStatus,
  setActionStatus,
  tableInfos,
  setTableInfos,
  clonedTableInfos,
  searchTypes,
}) => {
  const { error, isLoading, sendRequest: sendFetch } = useHttpFetch(false, "FNM");
  const { sendRequest: insert } = useHttpFetch(false, "FNM");
  const { sendRequest: update } = useHttpFetch(false, "FNM");
  const { sendRequest: getNetworkMarketerName } = useHttpFetch(false, "FNM");
  const [information, dto, view, fieldNameAddresses] = FormSupport();
  const [tempFocusedField, setTempFocusedField] = useState(null);
  const [updatedFields, setUpdatedFields] = useState("");
  const [data, setData] = useState(view);
  const createViewValidity = viewToViewValidity();
  const [formValidity, setFormValidity] = useState(createViewValidity(view));
  const [mappp, mapAndRemoveNullAttributes] = mapper();

  const navigate = useNavigate();
  const params = useParams();
  useEffect(() => {
    if (actionStatus === "editing" && editedData.id) {
      const callerer = async () => {
        try {
          const url = `mlmDataEntry/getNetworkMarketer?${`id==${editedData.id}`}`;
          const verifyReqOptions = {
            method: "GET",
            url: url,
            // noMiddleUrl: true,
            calType: "pe",
            language: "persian",
            port: "9092",
          };
          const response = await sendFetch(verifyReqOptions);
          if (
            response?.resIsOk &&
            response?.resStatus === 200 &&
            response?.response?.message !== "No record in DataBase!"
          ) {
            const recordRes = Array.isArray(response.response)
              ? response.response[0]
              : response.response.page?.[0];
            const updateData = mappp(recordRes, view);
            setData(updateData);
            const clonedDTO = structuredClone(updateData);
            const updateFormValidity = createViewValidity(updateData);
            setFormValidity(updateFormValidity);
          } else {
            toast.warn(response?.response?.message || "record data not found");
          }
        } catch (error) {
          console.log(error);
        }
      };

      callerer();
    }
  }, [editedData.id, actionStatus]);

  useEffect(() => {
    if (data?.superiorCode) {
      const getSuperiorName = async () => {
        try {
          const url = `mlmDataEntry/getNetworkMarketer?code==${data?.superiorCode}&page=1&size=10`;
          const verifyReqOptions = {
            method: "GET",
            url: url,
            // noMiddleUrl: true,
            calType: "pe",
            language: "persian",
            port: "9092",
          };
          const response = await getNetworkMarketerName(verifyReqOptions);
          if (
            response.resIsOk &&
            response.resStatus === 200 &&
            Array.isArray(response.response) &&
            response.response[0].name
          ) {
            const superiorName = response.response[0].name;
            setData((ps) => ({ ...ps, superiorName: superiorName }));
          } else {
            setData((ps) => ({ ...ps, superiorName: "بالادست وجود ندارد" }));
          }
        } catch (error) {
          console.log(error);
        }
      };
      getSuperiorName();
    }
    setData((ps) => ({ ...ps, superiorName: "" }));
  }, [data?.superiorCode]);

  const changeHandler = (value, pathString) => {
    setData((ps) => ({ ...ps, [pathString]: value }));
  };
  const validateHandler = (value, pathString) => {
    setFormValidity((ps) => ({ ...ps, [pathString]: value }));
  };
  const foucesHandlerForUpdate = (e) => {
    const value = e?.target ? e?.target?.value : e;
    setTempFocusedField(value);
  };
  const blurHandlerForUpdate = (e, address) => {
    const currentTrmpFocusedValue = tempFocusedField;
    const value = e?.target ? e?.target?.value : e;
    if (Object.prototype.toString.call(value) === "[object Object]" && "id" in value) {
      if (value?.id !== currentTrmpFocusedValue?.id) {
        setUpdatedFields((prevString) => {
          if (!prevString) {
            return address;
          } else if (!prevString.includes(address)) {
            return `${prevString},${address}`;
          }
          return prevString;
        });
      }
    } else if (value !== currentTrmpFocusedValue) {
      setUpdatedFields((prevString) => {
        if (!prevString) {
          return address;
        } else if (!prevString.includes(address)) {
          return `${prevString},${address}`;
        }
        return prevString;
      });
    }
    setTempFocusedField((ps) => null);
  };
  const cancelHandler = () => {
    // navigate("/form-network-marketer");
    setEditedData("");
    setActionStatus("");
    setHideSelectedData(false);
    setData(view);
    setFormValidity(createViewValidity(view));
  };
  const insertMainFormHandler = async () => {
    const datasAreValid = formValidator({
      data: data,
      setFormValidity,
      fieldNameAddresses,
      isInsertForm: true,
    });
    let dtoData = mappp(data, dto);

    if (datasAreValid) {
      const result = await insert({
        language: "persian",
        calType: "pe",
        url: "mlmDataEntry/insertNetworkMarketer",
        body: dtoData,
        method: "POST",
        port: "9092",
      });
      // Handle the result
      if (result?.resIsOk && result?.resStatus === 200) {
        toast.success("فرم با موفقیت ثبت شد");
        let fetchAttributes = {
          searchTypes: { ...searchTypes },
          search: { ...searchVal },
          sort: { ...sortIconName },
          page: 1,
          dataLimit,
          shouldFetchTotalNumber: true,
        };
        sendReqPerChange(fetchAttributes);
        setEditedData("");
        setActionStatus("");
        setHideSelectedData(false);
        setData(view);
      } else {
        toast.error("خطایی در ثبت فرم رخ داد");
      }
    }

    // setTimeout(async () => {
    // cancelHandler();
    // }, 400);
  };
  const updateMainFormHandler = async (action) => {
    const datasAreValid = formValidator({
      // data: filterEmptyArrays(data),
      data: data,
      setFormValidity,
      fieldNameAddresses,
      // fieldAccessesValidations: fieldAccessValidations,
    });

    let dtoData = mappp(data, dto);
    if (datasAreValid) {
      const result = await update({
        language: "persian",
        calType: "pe",
        url: `mlmDataEntry/updateNetworkMarketer?fields=${
          updatedFields ? removeDuplicatesFromArray(updatedFields) : ""
        }`,
        body: {
          ...dtoData,
          id: editedData?.id,
        },
        method: "PUT",
        port: "9092",
      });
      // Handle the result
      if (result?.resIsOk && result?.resStatus === 200) {
        toast.success("فرم با موفقیت به روزرسانی شد");
        let fetchAttributes = {
          searchTypes: { ...searchTypes },
          search: { ...searchVal },
          sort: { ...sortIconName },
          page: currentPage,
          dataLimit,
          shouldFetchTotalNumber: true,
        };
        console.log("before sendReqPerChange");
        sendReqPerChange(fetchAttributes);

        setEditedData("");
        setActionStatus("");
        setHideSelectedData(false);
        setData(view);
      } else {
        toast.error("خطایی در به روزرسانی فرم رخ داد");
      }
    }
  };
  return (
    <>
      <>
        {actionStatus === "editing" || actionStatus === "adding" ? (
          <tr className={classes.tr}>
            <td className={classes.tdData} />
            {tableInfos.find((tInf) => tInf.field === "name").show ? (
              <td className={classes.tdField}>
                <SimpleInput
                  value={data?.name}
                  fieldAddress="name"
                  onChange={(e) => changeHandler(e.target.value, e.target.name)}
                  label="نام و نام خانوادگی"
                  name="name"
                  // fieldName="FormNetworkMarketer_fullName"
                  // fieldAccesses={fieldAccesses}
                  validityName={formValidity?.name}
                  validateHandler={validateHandler}
                  type="text"
                  maxLength={100}
                  onFocus={foucesHandlerForUpdate}
                  onBlur={blurHandlerForUpdate}
                  skipFieldAccessCheck={true}
                />
              </td>
            ) : null}
            {tableInfos.find((tInf) => tInf.field === "code").show ? (
              <td className={classes.tdField}>
                <SimpleInput
                  value={data?.code}
                  fieldAddress="code"
                  onChange={(e) => changeHandler(e.target.value, e.target.name)}
                  label="کد"
                  name="code"
                  // fieldName="FormNetworkMarketer_code"
                  // fieldAccesses={fieldAccesses}
                  validityName={formValidity.code}
                  validateHandler={validateHandler}
                  type="number"
                  maxLength={100}
                  onFocus={foucesHandlerForUpdate}
                  onBlur={blurHandlerForUpdate}
                  skipFieldAccessCheck={true}
                />
              </td>
            ) : null}
            {tableInfos.find((tInf) => tInf.field === "superiorName").show ? (
              <td className={classes.tdField}>
                <SimpleInput
                  disabled={true}
                  value={data?.superiorName}
                  label={<MultiLanTxt tid="superiorName" />}
                  type="text"
                />
              </td>
            ) : null}
            {tableInfos.find((tInf) => tInf.field === "superiorCode").show ? (
              <td className={classes.tdField}>
                <SimpleInput
                  value={data?.superiorCode}
                  fieldAddress="superiorCode"
                  onChange={(e) => changeHandler(e.target.value, e.target.name)}
                  label={<MultiLanTxt tid="superiorCode" />}
                  name="superiorCode"
                  fieldName="FormNetworkMarketer_directSale"
                  // fieldAccesses={fieldAccesses}
                  validityName={formValidity.superiorCode}
                  validateHandler={validateHandler}
                  type="number"
                  maxLength={100}
                  onFocus={foucesHandlerForUpdate}
                  onBlur={blurHandlerForUpdate}
                  skipFieldAccessCheck={true}
                />
              </td>
            ) : null}
            {tableInfos.find((tInf) => tInf.field === "directSale").show ? (
              <td className={classes.tdField}>
                <SimpleInput
                  value={data?.directSale}
                  fieldAddress="directSale"
                  onChange={(e) => changeHandler(e.target.value, e.target.name)}
                  label={<MultiLanTxt tid="directSale" />}
                  name="directSale"
                  fieldName="FormNetworkMarketer_directSale"
                  // fieldAccesses={fieldAccesses}
                  validityName={formValidity.directSale}
                  validateHandler={validateHandler}
                  type="text"
                  maxLength={100}
                  onFocus={foucesHandlerForUpdate}
                  onBlur={blurHandlerForUpdate}
                  skipFieldAccessCheck={true}
                />
              </td>
            ) : null}

            <td className={classes.actionsContainer}>
              {isLoading ? (
                <span className={classes.spinnerContainer}>
                  <CircularProgress />
                </span>
              ) : (
                <CheckIcon
                  className={classes.actionIcon}
                  onClick={() =>
                    actionStatus === "editing" ? updateMainFormHandler() : insertMainFormHandler()
                  }
                />
              )}
              <ClearIcon className={classes.actionIcon} onClick={cancelHandler} />
            </td>
          </tr>
        ) : null}
      </>
    </>
  );
};

export default FormNetworkMarketerForm;
